import { Theme } from './theme';

export function getTabMenuStyles(theme: Theme) {
	const css = {
		tabMenu_css: {
			fontFamily: theme.tabMenu.fontFamily
		},
		tabHeader_css: {
			display: 'flex',
			borderBottom: theme.tabMenu.header.borderBottom
		},
		tabButton_css: {
			padding: theme.tabMenu.button.default.padding,
			border: 'none',
			background: 'none',
			cursor: 'pointer',
			fontSize: theme.tabMenu.button.default.fontSize,
			color: theme.tabMenu.button.default.color,
			position: 'relative' as const,
			transition: 'color 0.3s'
		},
		tabButtonHover_css: {
			color: theme.tabMenu.button.hover.color
		},
		tabButtonActive_css: {
			color: theme.tabMenu.button.active.color,
			fontWeight: 600
		},
		tabButtonDisabled_css: {
			color: theme.tabMenu.button.disabled.color,
			cursor: theme.tabMenu.button.disabled.cursor
		},
		activeIndicator_css: {
			content: '""',
			position: 'absolute' as const,
			bottom: '-1px',
			left: 0,
			width: '100%',
			height: theme.tabMenu.activeIndicator.height,
			backgroundColor: theme.tabMenu.activeIndicator.backgroundColor
		},
		tabContent_css: {
			padding: theme.tabMenu.content.padding
		},
		badge_css: {
			...theme.tabMenu.badge
		}
	};

	return css;
}
